import { ConnectionStatus } from '@cmctechnology/webinvest-api-client-market-data-ws';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authenticateToWebSocket, connectToWebSocket } from '../actions';
import { CLIENT_STORE_NAME, IStore } from '../store';
import { ClientRoles } from '../types';

export const useMarketDataWS = (authenticated: boolean) => {
  const dispatch = useDispatch();
  const crc = useSelector((store: IStore) => store.client.crc);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const connected = useSelector((store: IStore) => store.marketDataWs.connected);
  const connectionStatus = useSelector((store: IStore) => store.marketDataWs.connectionStatus);
  const isWsAuthenticated = useSelector((store: IStore) => store[CLIENT_STORE_NAME].isWsAuthenticated);
  const roles = useSelector((store: IStore) => store[CLIENT_STORE_NAME].roles);
  const accessMarketDataSubscriber = roles.includes(ClientRoles.ACCESS_MARKETDATA_SUBSCRIBER);
  const canUseWs = isAuthenticated && accessMarketDataSubscriber;

  useEffect(() => setIsAuthenticated(authenticated && !!crc), [authenticated, crc]);

  useEffect(() => {
    if (canUseWs && connectionStatus === ConnectionStatus.Disconnected) {
      dispatch<any>(connectToWebSocket());
    }
  }, [canUseWs, connectionStatus]);

  useEffect(() => {
    if (canUseWs && connectionStatus === ConnectionStatus.Connected && !isWsAuthenticated) {
      dispatch<any>(authenticateToWebSocket());
    }
  }, [canUseWs, connectionStatus, isWsAuthenticated]);

  return { connected, connectionStatus, isWsAuthenticated };
};
